<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
const [name] = createNamespace('CurrencyCenterResettleStandardDisplay')

export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>,
      default: () => ({})
    }
  },
  setup(props) {
    return () => (
      <div class='ant-row-form-item'>
        安置标准：
        <b>{props.data.huoBiHuaAnZhiChengQu} 元/人</b>
        (包括过渡费、简装补助等)执行。
      </div>
    )
  }
})
</script>
